import asyncSessionLoader from "../../../../../../core/gd/data/async-session-loader"
import ApiProject from "../../../../../../core/gd/api/project"
import {ProjectSystemType} from "../../../../../../core/model2/project/types"
import {ViewType} from "../../../../../../core/gd/const/views/view-type"
import {EmbedType} from "../../../../../../core/gd/const/embed/embed-type"

type APICallParams = {
    company?        : ID
    parentProject?  : ID
    name            : string
    embedCode?      : string
    owner?          : string
    color?          : number
    projectIcon?    : string
    embedType       : EmbedType
}

const debug = false
// const debug = 'quickAdd_createEmbed'

export default async function quickAdd_createEmbed(params: APICallParams, onProjectAdded?: callback) {
    /*// create project for Embed
    const data = await gd.api.Project.newWorkfolder(params).promise()

    onProjectAdded && onProjectAdded()

    const project: ProjectSession = gd.session.projects.get(data.projectId)
    project.properties.embedCode = params.embedCode
    await gd.api.Project.setProperties(project.id, project.properties).promise()

    debug && console.log(debug, 'onSubmit project', project.settings)

    return project*/

    await asyncSessionLoader(gd.session.findMissing({
        // @ts-ignore
        projectsSettings: [params.parentProject, ...gd.session.projects.getAllParentsIds(params.parentProject)]
    }))

    // create project for Embed
    /*const data = await ApiProject.newEmbed({
        parentProjectId : params.parentProject,
        name            : params.name,
        color           : params.color,
        embedCode       : params.embedCode,
    }).promise()*/

    const data = await ApiProject.newResource({
        parentProjectId : params.parentProject,
        name            : params.name,
        systemType      : ProjectSystemType.EMBED,
        color           : params.color,
        projectIcon     : params.projectIcon,
    }).promise()

    // load settings of just created project
    await asyncSessionLoader(gd.session.findMissing({
        projectsSettings: [data.projectId],
    }))

    const project = gd.session.projects.get(data.projectId)!

    // create page view with embedCode
    const newId = gd.utils.generateUIDWithCollisionChecking()
    project.settings!.views = [{
        id                  : newId,
        isPinned            : true,
        systemType          : ViewType.PROJECT_EMBED,
        defaultEmbedType    : params.embedType,
        embedCode           : params.embedCode
    }]
    project.settings!.defaultView = newId
    project.settings!.save()

    return project
}